import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";

import Input from "../ReadOnlyInput";
import { formatMonetary } from "../../../../utils/formats";
import Table from "../../subcomponents/Table";
import { Label, Separator } from "../styles";
import TablePagination from "@mui/material/TablePagination";
import { makeStyles } from "@mui/styles";
import { retrieveOtherProposals } from "../../../../services/frontCredito";
import { toast } from "react-toastify";

const columns = [
  { id: "numeroProposta", name: "Contrato" },
  { id: "situacaoExpandida", name: "Situação" },
  { id: "valorPrestacao", name: "Valor da Parcela", render: formatMonetary },
  { id: "saldoDevedor", name: "Saldo Devedor", render: formatMonetary },
  { id: "descricaoCaracteristica", name: "Característica" },
];

const useStyles = makeStyles({
  caption: {
    padding: 8,
    fontSize: "1.25rem",
  },
  toolbar: {
    "& > p:nth-of-type(2)": {
      fontSize: "1.25rem",
      color: "red",
      fontWeight: 600,
    },
  },
});

const HistoricoPagamentosSection = (props) => {
  const [totalElements, setTotalElements] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const { resumoPropostas = [], resumoPropostasLoading, cpfCnpj } = props;

  const [filters, setFilters] = useState({
    cpfCnpj: cpfCnpj,
    pageable: {
      page: 0,
      size: 5,
      sortColumn: "numeroProposta",
      sortDirection: "ASC",
    },
  });

  useEffect(() => {
    getDataByFilters();
  }, [filters]);

  const getDataByFilters = () => {
    setIsLoading(true);
    setRows([]);
    setTotalElements(0);

    retrieveOtherProposals(filters)
      .then((response) => {
        if (response && (response.status === 201 || response.status === 200)) {
          const {
            data: { content, totalElements },
          } = response;

          setRows(content);
          setTotalElements(totalElements);
        } else if (!response) {
          toast.error("Erro ao buscar os dados.");
        }
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error("Erro ao buscar os dados.");
        }
      })
      .finally(() => setIsLoading(false));
  };

  const handleChangePage = (p, newPage) => {
    setFilters({
      ...filters,
      cpfCnpj: cpfCnpj,
      pageable: {
        ...filters.pageable,
        page: newPage,
      },
    });
  };

  const classes = useStyles();

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Table
            loading={isLoading}
            noDataMessage="SEM DADOS."
            entries={rows}
            columns={columns}
          />
          <TablePagination
            component="div"
            classes={{
              toolbar: classes.toolbar,
              caption: classes.caption,
            }}
            count={totalElements}
            page={filters.pageable.page || 0}
            labelDisplayedRows={({ from, to, count }) =>
              `${from} - ${to} de ${count}`
            }
            onPageChange={handleChangePage}
            rowsPerPageOptions={[]}
            rowsPerPage={filters.pageable.size}
          />
        </Grid>
      </Grid>
      <Separator />
      <Label>Resumo</Label>
      <Grid container spacing={3}>
        <Grid item lg={1} sx={{ display: { xs: "none", xl: "block" } }}>
          {/*Empty*/}
        </Grid>
        <Grid item xs={8} md={4} lg={3} xl={2}>
          <Label height="100%" align="center">
            Total de contratos
          </Label>
        </Grid>
        <Grid item xs={4} md={2}>
          <Input
            loading={resumoPropostasLoading}
            value={resumoPropostas.quantidadeContratos}
          />
        </Grid>
        <Grid item lg={1} sx={{ display: { xs: "none", xl: "block" } }}>
          {/*Empty*/}
        </Grid>
        <Grid item xs={8} md={4} lg={3} xl={2}>
          <Label height="100%" align="center">
            Total de prestações pagas em atraso
          </Label>
        </Grid>
        <Grid item xs={4} md={2}>
          <Input
            loading={resumoPropostasLoading}
            value={resumoPropostas.quantidadePrestacoesAtrasadas}
          />
        </Grid>
        <Grid item lg={2} sx={{ display: { xs: "none", xl: "block" } }}>
          {/*Empty*/}
        </Grid>

        <Grid item lg={1} sx={{ display: { xs: "none", xl: "block" } }}>
          {/*Empty*/}
        </Grid>
        <Grid item xs={8} md={4} lg={3} xl={2}>
          <Label height="100%" align="center">
            Total de prestações pagas em dia
          </Label>
        </Grid>
        <Grid item xs={4} md={2}>
          <Input
            loading={resumoPropostasLoading}
            value={resumoPropostas.quantidadePrestacoesPagaEmDia}
          />
        </Grid>
        <Grid item lg={1} sx={{ display: { xs: "none", xl: "block" } }}>
          {/*Empty*/}
        </Grid>
        <Grid item xs={8} md={4} lg={3} xl={2}>
          <Label height="100%" align="center">
            Relação da proporção de inadimplência
          </Label>
        </Grid>
        <Grid item xs={4} md={2}>
          <Input
            loading={resumoPropostasLoading}
            value={resumoPropostas.relacaoProporcaoInadiplencia}
          />
        </Grid>
        <Grid item lg={2} sx={{ display: { xs: "none", xl: "block" } }}>
          {/*Empty*/}
        </Grid>
      </Grid>
    </>
  );
};

export default HistoricoPagamentosSection;
